import { render, staticRenderFns } from "./CashbackAdjustmentsTable.vue?vue&type=template&id=738d9084&scoped=true"
import script from "./CashbackAdjustmentsTable.vue?vue&type=script&lang=js"
export * from "./CashbackAdjustmentsTable.vue?vue&type=script&lang=js"
import style0 from "./CashbackAdjustmentsTable.vue?vue&type=style&index=0&id=738d9084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738d9084",
  null
  
)

export default component.exports